/**
 * @author Eric Otto
 */

module.exports = {
    init: function ($container) {
        'use strict';

        const images = $container
            ? $container.querySelectorAll('img[data-1x]')
            : document.querySelectorAll('img[data-1x]');

        if (!images.length) {
            return;
        }

        for (let i = 0; i < images.length; i++) {
            const src = (this.isRetina() === true)
                ? images[i].getAttribute('data-2x')
                : images[i].getAttribute('data-1x');

            images[i].setAttribute('src', src);
        }
    },

    isRetina: function () {
        return window.devicePixelRatio === 2;
    }
};
